import React, { useState } from 'react';
import { useAuth } from '../../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import './AdminLogin.css';

const IconEye = ({ off }) => off ? (
  <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
    <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="1" y1="1" x2="23" y2="23" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
) : (
  <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

const IconLock = () => (
  <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
    <rect x="3" y="11" width="18" height="11" rx="2" stroke="currentColor" strokeWidth="2"/>
    <path d="M7 11V7a5 5 0 0110 0v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const IconUser = () => (
  <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
    <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

const IconAlert = () => (
  <svg viewBox="0 0 24 24" fill="none" width="16" height="16">
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
    <line x1="12" y1="8" x2="12" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <line x1="12" y1="16" x2="12.01" y2="16" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
  </svg>
);

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate   = useNavigate();

  const [form,     setForm]     = useState({ username: '', password: '' });
  const [showPass, setShowPass] = useState(false);
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);

  const handleChange = e => {
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));
    if (error) setError('');
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!form.username || !form.password) { setError('Completa todos los campos'); return; }
    setLoading(true);
    // pequeño delay para UX
    await new Promise(r => setTimeout(r, 600));
    const result = login(form.username, form.password);
    setLoading(false);
    if (result.ok) {
      navigate('/admin/dashboard');
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="al-page">
      {/* Fondo decorativo */}
      <div className="al-bg">
        <div className="al-bg__blob al-bg__blob--a" />
        <div className="al-bg__blob al-bg__blob--b" />
        <div className="al-bg__grid" aria-hidden="true" />
      </div>

      {/* Panel izquierdo — marca */}
      <div className="al-brand">
        <div className="al-brand__inner">
          <a href="/" className="al-brand__logo">
            <span className="al-brand__logo-mark" />Comunicar
          </a>
          <div className="al-brand__copy">
            <h2>Panel de<br /><em>administración</em></h2>
            <p>Gestiona formaciones, recursos, ventas y comunidad desde un solo lugar.</p>
          </div>
          <div className="al-brand__stats">
            <div className="al-stat"><strong>30+</strong><span>Formaciones</span></div>
            <div className="al-stat"><strong>120+</strong><span>Recursos</span></div>
            <div className="al-stat"><strong>2,000+</strong><span>Usuarios</span></div>
          </div>
          <div className="al-brand__decoration">
            <div className="al-dec al-dec--a" />
            <div className="al-dec al-dec--b" />
            <div className="al-dec al-dec--c" />
          </div>
        </div>
      </div>

      {/* Panel derecho — form */}
      <div className="al-form-panel">
        <div className="al-form-wrap">
          <div className="al-form-head">
            <h1>Iniciar sesión</h1>
            <p>Acceso exclusivo para administradores de Comunicar</p>
          </div>

          <form className="al-form" onSubmit={handleSubmit} noValidate>
            {/* Username */}
            <div className={`al-field ${error ? 'al-field--error' : ''}`}>
              <label htmlFor="al-username">Usuario</label>
              <div className="al-field__wrap">
                <span className="al-field__icon"><IconUser /></span>
                <input
                  id="al-username"
                  type="text"
                  name="username"
                  autoComplete="username"
                  placeholder="Ingresa tu usuario"
                  value={form.username}
                  onChange={handleChange}
                  className="al-input"
                />
              </div>
            </div>

            {/* Password */}
            <div className={`al-field ${error ? 'al-field--error' : ''}`}>
              <label htmlFor="al-password">Contraseña</label>
              <div className="al-field__wrap">
                <span className="al-field__icon"><IconLock /></span>
                <input
                  id="al-password"
                  type={showPass ? 'text' : 'password'}
                  name="password"
                  autoComplete="current-password"
                  placeholder="••••••••••••"
                  value={form.password}
                  onChange={handleChange}
                  className="al-input"
                />
                <button
                  type="button"
                  className="al-field__eye"
                  onClick={() => setShowPass(v => !v)}
                  aria-label={showPass ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                >
                  <IconEye off={showPass} />
                </button>
              </div>
            </div>

            {/* Error */}
            {error && (
              <div className="al-error" role="alert">
                <IconAlert />{error}
              </div>
            )}

            {/* Submit */}
            <button
              type="submit"
              className={`al-submit ${loading ? 'al-submit--loading' : ''}`}
              disabled={loading}
            >
              {loading ? (
                <span className="al-spinner" />
              ) : (
                'Ingresar al panel'
              )}
            </button>
          </form>

          <p className="al-back">
            <a href="/">← Volver al sitio web</a>
          </p>
        </div>
      </div>
    </div>
  );
}